import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography
} from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import i18n from 'translations/langEngine';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { FlightLand as FlightLandIcon } from '@material-ui/icons';
import { Dashboard_Translations } from 'translations/translationKeys';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    backgroundColor: '#f5f5f5',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: 8
  },
  title: {
    fontWeight: 700,
    color: '#333'
  },
  avatar: {
    backgroundColor: '#1E88E5',
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32,
    color: '#FFFFFF'
  },
  totalPax: {
    transition: 'opacity 0.5s ease-in-out',
    opacity: 0,
    fontWeight: 'bold',
    color: '#1E88E5'
  },
  totalPaxLoaded: { opacity: 1 }
}));

/* Card da dashboard com o total de passageiros chegando */
const TotalPaxChegando = props => {
  const {
    className,
    totalPaxTransito,
    ...rest
  } = props;

  // busca a tradução do rótulo "Chegadas"
  useEffect(() => {
    let isMounted = true;

    const termsNeeded = [Dashboard_Translations.LABEL_CHEGADAS];

    i18n.fetchTerms(termsNeeded).then(translations => {
      if (isMounted) {
        setTranslations(translations);
      }
    }).catch(error => {
      console.error('Erro ao carregar traduções:', error);
    });

    // evita setState após o componente desmontar
    return () => {
      isMounted = false;
    };
  }, []);

  const classes = useStyles();
  const [translations, setTranslations] = useState({});
  const lblChegadas = translations[Dashboard_Translations.LABEL_CHEGADAS];

  return (
    <Card
      {...rest}
      className={clsx(
        classes.root,
        className
      )}
    >
      <CardContent>
        <Grid
          container
          justifyContent="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              {lblChegadas || "CHEGADAS"}
            </Typography>

            <Typography
              variant="h3"
              className={clsx(
                classes.totalPax,
                {
                  [classes.totalPaxLoaded]: totalPaxTransito !== undefined
                }
              )}
            >
              {totalPaxTransito !== undefined ? totalPaxTransito : ''}
            </Typography>
          </Grid>

          <Grid item>
            <Avatar className={classes.avatar}>
              <FlightLandIcon
                className={classes.icon}
              />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

TotalPaxChegando.propTypes = {
  className: PropTypes.string,
  totalPaxTransito: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
};

export default TotalPaxChegando;